module.exports = __webpack_public_path__ + "img/x.12c6c3a2.svg";